import styled, {
  SystemProp,
  Theme,
  ThemeSize,
  css
} from '@xstyled/styled-components';
import * as CSS from 'csstype';
import React from 'react';
import { Item, registry, RenderProps } from '../Item';
import { PERSONALIZED_CARD } from '../itemIds';
import { Logo } from '~/ui/logo/Logo';
import { TrainingState, useTrainingStore } from '~/training/state';
import { select } from '~/lib/select';

import myImage from '../../../../../assets/personalization/bg.png';

interface Props {
  alt?: string;
  backgroundColor?: string;
  className?: string;
  showLogo?: boolean;
  vertical?: boolean;
  width?: SystemProp<ThemeSize<Theme> | CSS.Property.Width, Theme>;
  height?: SystemProp<ThemeSize<Theme> | CSS.Property.Height, Theme>;
}

const DivEl = styled.div<Props>`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--color-accent-dk);
  img {
    ${p =>
      p.vertical
        ? css`
            height: 80%;
          `
        : css`
            width: 80%;
          `}
  }
`;

const ImgEl = styled.img`
  height: 100% !important;
  width: 100% !important;
  border: 4px solid #fff !important;
  border-radius: 20px !important;
`;

const selector = (s: TrainingState) => select(s, 'logoUrl');

export class PersonalizedCard extends Item<typeof PERSONALIZED_CARD, Props> {
  protected render({
    parent,
    width,
    height,
    vertical,
    backgroundColor,
    showLogo,
    ...props
  }: RenderProps<Props>) {
    const { logoUrl } = useTrainingStore(selector);

    return showLogo ? (
      <DivEl vertical={vertical}>
        <Logo src={logoUrl} />
      </DivEl>
    ) : (
      <DivEl vertical={vertical}>
        <ImgEl src={myImage} alt="Image for card" />
      </DivEl>
    );
  }
}

registry[PERSONALIZED_CARD] = PersonalizedCard;
